import IClose from '@imgs/icons/close.svg';
import IError from '@imgs/icons/error.svg';
import IHint from '@imgs/icons/hint.svg';
import ISuccess from '@imgs/icons/success.svg';
import type { ModalFuncProps, ModalProps } from 'antd';
import { Modal } from 'antd';
import classNames from 'classnames';
import styles from './index.less';

export interface ResetModalProps extends ModalProps {
  children?: Element[] | React.ReactNode;
  onClickCloseBtn?: () => void;
  fixedBottom?: boolean; // 是否贴底
}

export function ModalConfirm(param: ModalFuncProps) {
  const { confirm } = Modal;
  return confirm({
    icon: param.icon || (
      <IHint className='anticon' style={{ width: 22, height: 22 }}></IHint>
    ),
    centered: true,
    maskClosable: false,
    ...param,
  });
}

export function ModalInfo(param: ModalFuncProps) {
  const { info } = Modal;
  return info({
    icon: param.icon || (
      <IHint className='anticon' style={{ width: 22, height: 22 }}></IHint>
    ),
    centered: true,
    maskClosable: false,
    ...param,
  });
}

export function ModalError(param: ModalFuncProps) {
  const { error } = Modal;
  return error({
    icon: (
      <IError className='anticon' style={{ width: 22, height: 22 }}></IError>
    ),
    centered: true,
    maskClosable: false,
    ...param,
  });
}

export function ModalWarning(param: ModalFuncProps) {
  const { warning } = Modal;
  return warning({
    icon: <IHint className='anticon' style={{ width: 22, height: 22 }}></IHint>,
    centered: true,
    maskClosable: false,
    ...param,
  });
}

export function ModalSuccess(param: ModalFuncProps) {
  const { success } = Modal;
  return success({
    icon: (
      <ISuccess
        className='anticon'
        style={{ width: 22, height: 22 }}
      ></ISuccess>
    ),
    centered: true,
    maskClosable: false,
    ...param,
  });
}

export const ResetModal = (props: ResetModalProps) => {
  return (
    <Modal
      closable={!!props.title}
      closeIcon={
        <IClose
          width={20}
          height={20}
          onClick={() => props?.onClickCloseBtn?.()}
        />
      }
      centered={
        props.centered === undefined || !props.fixedBottom
          ? true
          : props.centered
      }
      maskClosable={false}
      {...props}
      wrapClassName={classNames(
        { [styles['fixed-bottom-modal-wrap']]: props.fixedBottom },
        props.wrapClassName
      )}
      className={classNames(
        { [styles['fixed-bottom-modal']]: props.fixedBottom },
        props.className
      )}
      style={{
        ...props.style,
        ...(props.fixedBottom
          ? {
              height: `calc(100vh - ${props?.style?.top}px)`,
              boxSizing: 'unset',
            }
          : {}),
      }}
    >
      {props?.children}
    </Modal>
  );
};
